@if (textSeo(); as data) {
  <div class="centered-with-padding">
    <div
      [class.bg-gray-light]="data.background === 'gray'"
      [class.bg-white]="data.background === 'white'"
      class="rounded-3xl px-9 py-7 desk:px-12 desk:py-9">
      @let showAllText = !!data.showFullText;
      @let hasScrollActivated = hasScroll() && !showAllText;
      @let textClass =
        "prose max-w-full prose-h1:text-[18px] prose-h2:mb-2 prose-h2:mt-0 prose-h2:text-[16px] prose-h3:my-0 prose-h3:text-[16px] prose-p:my-2.5 prose-p:text-[14px] prose-p:font-medium prose-p:leading-normal";
      @if (isOpen() || showAllText) {
        <div
          [class]="textClass"
          [class.max-h-full]="showAllText"
          [class.max-h-[500px]]="hasScrollActivated"
          [class.h-[60svh]]="hasScrollActivated"
          [class.desk:h-auto]="hasScrollActivated"
          [class.desk:max-h-[350px]]="hasScrollActivated"
          [class.overflow-y-auto]="hasScrollActivated"
          [class.pr-2]="hasScrollActivated"
          [class.mb-2]="hasScrollActivated"
          [innerHtml]="data.text"
          handleHtmlLinks></div>
      } @else {
        <div class="line-clamp-5" [class]="textClass" [innerHtml]="data.text" handleHtmlLinks></div>
      }

      @if (!showAllText) {
        @if (!isOpen()) {
          <div (click)="isOpen.set(true)" class="cursor-pointer text-center font-bold underline">
            {{ "COMPONENT.TEXTE-SEO.SEE_MORE" | translate }}
          </div>
        } @else {
          <div (click)="isOpen.set(false)" class="cursor-pointer text-center font-bold underline">
            {{ "COMPONENT.TEXTE-SEO.SEE_LESS" | translate }}
          </div>
        }
      }
    </div>
  </div>
}
